export default __webpack_public_path__ + "static/media/chat-vec.978fca90.png";